const initState = {
  frames: [] as Frame[],
  categories: [] as Category[],
  lenses: [] as Lenses[],
  lensMaterial: [] as LensMaterial[],
  lensColors: [] as LensColorType[],
  options: [] as Upgrade[],
  advancedOptions: [] as AdvancedOption[],
};

export default function (state = initState, action: any) {
  switch (action.type) {
    case "SET_FRAMES":
      return {
        ...state,
        frames: action.data,
      };
    case "SET_CATEGORIES":
      return {
        ...state,
        categories: action.data,
      };
    case "SET_LENSES":
      return {
        ...state,
        lenses: action.data,
      };
    case "SET_LENS_MATERIAL":
      return {
        ...state,
        lensMaterial: action.data,
      };
    case "SET_LENS_COLORS":
      return {
        ...state,
        lensColors: action.data,
      };
    case "SET_OPTIONS":
      return {
        ...state,
        options: action.data,
      };
    case "SET_ADVANCED_OPTIONS":
      return {
        ...state,
        advancedOptions: action.data,
      };
    default:
      return state;
  }
}
